import React from 'react';
import { bool, shape, string } from 'prop-types';

const ColorMarker = ({
  className = 'icon',
  notUseClass = false,
  style = { color: '#696f88' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1.1em" height="1.1em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect width="1.1em" height="1.1em" rx="4" fill="currentColor" />
  </svg>
);

ColorMarker.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default ColorMarker;
